import { useTranslation } from 'react-i18next';

import Legals, {
	formatLocalizedDate,
	useStaticTexts
} from '@/components/Legals';
import { useLanguage } from '@/hooks/user';

const LAST_UPDATE_DATE = '2024-09-20';

function PrivacyPolicy() {
	const { t } = useTranslation();
	const locale = useLanguage();

	const content = useStaticTexts('privacyPolicy');

	return (
		<Legals
			content={content}
			title={t('pageTitles.privacy')}
			subtitle={t('legals.lastUpdated', {
				date: formatLocalizedDate(LAST_UPDATE_DATE, locale)
			})}
		/>
	);
}

export default PrivacyPolicy;
